import Container from 'typedi';
import { IEvent } from '@888unifiedclient/event-formatter';
import { LoggerProvider } from '../src/modules/logger';
import { HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

export default class ClickStreamApi {
    public static SendReport = async <T>(data: IEvent<T, 'UCEvent' | string>): Promise<void> => {
        const logger = Container.get(LoggerProvider).getLogger('ClickStreamApi');
        const clickStreamUrl = window.pageContextManager.getUrlResourceData().clickStreamUrl;

        if (!clickStreamUrl) {
            logger.warn('Clickstream URL is missing...');
            return;
        }

        const formattedData = JSON.stringify(data);

        const { response } = await ApiManager.getNonServiceInstance().request({
            url: clickStreamUrl,
            method: HTTPVerb.POST,
            data: formattedData,
            withCredentials: false,
            headers: { 'content-type': 'application/json' },
        });

        if (response) {
            logger.debug(`The following event was successfully sent: ${formattedData}`);
        }
    };
}
